import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import MainPage from './pages/MainPage';
import SectionPage from './pages/SectionPage';
import ArticlePage from './pages/ArticlePage';
import './App.css'; // Import the CSS file

// Import font faces globally
import './fonts.css'; // Centralize font declarations

const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Router>
      <div className={`app-container ${menuOpen ? 'menu-open' : ''}`}>
        <div className="content">
          <Routes>
            <Route exact path="/" element={<MainPage />} />
            <Route path="/section/:identifier" element={<SectionPage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
